import UserAvatar from "@/components/shared/UserAvatar";

import { useToast } from "@/hooks/useToast";

import { Button } from "@/components/primitives/button";
import { MessagesSquare } from "lucide-react";
import { createDMChat } from "@/middleware/chats";
import { useTranslation } from "react-i18next";

type Props = {
  username: string;
};

export default function SearchedMemberListItem({ username }: Props) {
  const { t } = useTranslation();

  const { toast } = useToast();

  const handleCreateDMChat = async (withUser: string) => {
    try {
      await createDMChat(withUser);
    } catch (error) {
      toast({
        duration: 1000,
        description:
          error instanceof Error ? error.message : t("errorOccurred"),
        variant: "destructive",
      });
    }
  };

  return (
    <div
      onClick={() => handleCreateDMChat(username)}
      className="flex cursor-pointer items-center justify-start gap-3 px-4 py-2 align-middle hover:bg-foreground/5"
    >
      <UserAvatar username={username} className="size-8" />

      <h3 className="truncate">{username} </h3>

      <Button
        className="ml-auto size-4 cursor-pointer"
        size="icon"
        variant="ghost"
      >
        <MessagesSquare />
      </Button>
    </div>
  );
}
